import { API_URL } from "configs";

/** Same base used for other `/api/...` axios calls (no trailing slash). */
export const getAppraisalApiBase = () => String(API_URL || "").trim().replace(/\/$/, "");

export const getAppraisalAttachmentId = (attachment) =>
  attachment?.attachment_id ?? attachment?.id ?? "";

export const getAppraisalAttachmentFileName = (attachment) =>
  attachment?.file_name || attachment?.original_file_name || "Attachment";

/**
 * Absolute URL for viewing/downloading an attachment in the browser.
 * Backend returns `secure_view_url` as a relative path; prepend API base.
 */
export const resolveAppraisalAttachmentSecureViewUrl = (attachment) => {
  if (!attachment) return "";

  const raw = attachment.secure_view_url;
  if (raw === null || raw === undefined || String(raw).trim() === "") {
    return "";
  }

  const path = String(raw).trim();
  if (/^https?:\/\//i.test(path) || /^data:image\//i.test(path) || /^blob:/i.test(path)) {
    return path;
  }

  const apiBase = getAppraisalApiBase();
  if (!apiBase) return path;

  const relative = path.startsWith("/") ? path : `/${path}`;

  // Avoid `/api` + `/api/attachments/...` when backend path includes the `/api` prefix.
  if (/\/api$/i.test(apiBase) && relative.startsWith("/api/")) {
    return `${apiBase.replace(/\/api$/i, "")}${relative}`;
  }

  return `${apiBase}${relative}`;
};
